var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { PopupMessage, Popup, PopupupMessageComponents, PopupMessageTypeClasses } from "sb-resp-ui";
import { Counter } from "../Counter";
import { DeviceDetect } from "sb-resp-utils";
import { RandomCoinsFactory } from "../RandomCoinsFactory";
import { observable } from "mobx";
import { observer } from "mobx-react";
let JackpotWinningAnimation = class JackpotWinningAnimation extends React.Component {
    constructor(props) {
        super(props);
        this.deviceDetect = DeviceDetect.getInstance();
        this.isLoadingImgs = true;
        this.coinsImg = ["/imgs/jackpot/coins.png", "/imgs/jackpot/coins-medium.png", "/imgs/jackpot/coins-small.png", props.image.Src];
        this.setPopupPanelOpen = this.setPopupPanelOpen.bind(this);
    }
    componentDidMount() {
        if (!this.isLoadingImgs) {
            this.isLoadingImgs = false;
        }
        let waitImgPromises = this.coinsImg.map(x => {
            return new Promise((resolve, reject) => {
                let img = document.createElement("img");
                img.onload = resolve;
                img.onerror = resolve;
                img.src = x;
            });
        });
        /* istanbul ignore next */
        Promise.all(waitImgPromises).then(x => {
            this.isLoadingImgs = false;
        }).catch(x => { this.isLoadingImgs = false; });
    }
    render() {
        const { dict, eventName, amount, currencyCode, image, setWinning } = this.props;
        if (this.isLoadingImgs) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null, this.renderWinningAnimationPopup(dict, eventName, amount, currencyCode, image.Src, setWinning)));
    }
    setPopupPanelOpen(show) {
        if (show) {
            document.body.classList.add("jackpot-popup-open", "jackpot-winning-animation-open");
        }
        else {
            document.body.classList.remove("jackpot-popup-open", "jackpot-winning-animation-open");
        }
    }
    renderWinningAnimationPopup(dict, eventName, amount, currencyCode, src, setWinning) {
        var backgroundImage = {
            backgroundImage: `url('${src}')`
        };
        const config = {
            className: "rj-jackpot-winning-animation",
            isInIframe: false,
            hasCloseBtn: false,
            hasOverlay: false,
            beforeHideCallback: /* istanbul ignore next */ () => {
                this.setPopupPanelOpen(false);
            },
            beforeShowCallback: /* istanbul ignore next */ () => {
                this.setPopupPanelOpen(true);
            }
        };
        const coinsCount = this.deviceDetect.isDesktop ? 40 : 20;
        const msgConfigContent = {
            type: PopupMessageTypeClasses.dialog,
            className: "rj-jackpot-winning-animation-popup-message",
            actions: {}
        };
        function createMarkup() { return { __html: "First &middot; Second" }; }
        ;
        React.createElement("div", { dangerouslySetInnerHTML: createMarkup() });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "rj-popup-message__close-btn rj-jackpot-winning-animation__close-btn", onClick: /* istanbul ignore next */ () => setWinning(true) },
                React.createElement("span", { className: "icon i-14 i-o-controls-close" })),
            React.createElement("div", { className: "rj-jackpot-winning-animation-wrapper", style: backgroundImage },
                React.createElement("div", { id: "jackpot-winning-animation-container", className: "rj-jackpot-winning-animation-container" },
                    React.createElement(RandomCoinsFactory, { count: coinsCount })),
                React.createElement(Popup, { config: config },
                    React.createElement(PopupMessage, { config: msgConfigContent },
                        React.createElement("div", { id: "rj-jackpot-winning-animation-popup-msg-body" },
                            React.createElement(PopupupMessageComponents.Body, { actions: msgConfigContent.actions },
                                React.createElement("div", { className: "rj-jackpot-winning-animation__animated-wrapper" },
                                    React.createElement("div", { className: "rj-jackpot-winning-animation__title" },
                                        React.createElement("span", null,
                                            dict.YouWonJackpot,
                                            " ",
                                            React.createElement("br", null),
                                            eventName)),
                                    React.createElement(Counter, { total: amount, currencyCode: currencyCode })),
                                React.createElement("button", { className: "rj-jackpot-winning-animation__button", onClick: /* istanbul ignore next */ () => setWinning(true) }, dict.BackToBetting))))))));
    }
};
__decorate([
    observable,
    __metadata("design:type", Boolean)
], JackpotWinningAnimation.prototype, "isLoadingImgs", void 0);
JackpotWinningAnimation = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], JackpotWinningAnimation);
export { JackpotWinningAnimation };
//# sourceMappingURL=JackpotWinningAnimation.js.map